(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const words = ['Common Breed', 'Pet Toys', 'Cat Basket', 'Bird Food', 'Dog Treats'];

    const input = document.querySelector('#site-search');
    const typed = document.querySelector('.typed-text');
    const cursor = document.querySelector('.cursor');
    const searchPlaceholderWrapper = document.querySelector('.search-placeholder');
    let searMainWrapper = document.querySelector('.new-header-search-wrapper');
    let searMainOverlay = document.querySelector('.new-header-search-overlay');
    const revealMsPerChar = 35;
    const hideMsPerChar = 55;
    const minRevealMs = 220;
    const minHideMs = 260;

    const pauseAfterTyped = 700;
    const pauseBeforeNext = 900;

    let wordIndex = 0;
    let timer = null;

    function isUserActive() {
      return document.activeElement === input || input.value.length > 0;
    }
    function updatePlaceholderVisibility() {
      if (isUserActive()) {
        searchPlaceholderWrapper.style.opacity = '0';
        searchPlaceholderWrapper.style.visibility = 'hidden';
        searMainWrapper.classList.add('active');
        searMainOverlay.classList.add('is-visible');
        document.body.classList.add('overflow-hidden-megamenu');
        input.style.color = 'inherit';
        window.PlpCardLayout?.scheduleUpdate?.(document.querySelector('new-search'));
      } else {
        searchPlaceholderWrapper.style.opacity = '1';
        searchPlaceholderWrapper.style.visibility = 'visible';
        searMainWrapper.classList.remove('active');
        searMainOverlay.classList.remove('is-visible');
        document.body.classList.remove('overflow-hidden-megamenu');
        input.style.color = 'transparent';
      }
    }

    input.addEventListener('focus', updatePlaceholderVisibility);

    document.addEventListener('mousedown', function (e) {
      if (e.target.closest('quick-add-modal')) {
        return;
      }
      const clickedInsideInput = input.contains(e.target);
      const clickedInsideWrapper = searMainWrapper.contains(e.target);
      const clickedInsideSearchField = Boolean(e.target.closest('.search-container'));

      if (!clickedInsideInput && !clickedInsideWrapper && !clickedInsideSearchField) {
        const wasOpen = searMainWrapper.classList.contains('active');

        searchPlaceholderWrapper.style.opacity = '1';
        searchPlaceholderWrapper.style.visibility = 'visible';
        searMainWrapper.classList.remove('active');
        searMainOverlay.classList.remove('is-visible');
        document.body.classList.remove('overflow-hidden-megamenu');
        input.style.color = 'transparent';

        // Reset after this event finishes. Doing it during mousedown (and
        // especially calling blur()) cancels the focus that opens the dropdown.
        if (wasOpen) {
          const newSearchEl = document.querySelector('new-search');
          if (newSearchEl && typeof newSearchEl.resetSearch === 'function') {
            setTimeout(() => newSearchEl.resetSearch(), 0);
          }
        }
      }
      if (!e.target.closest('new-search')) {
        document.querySelector('.section-header').classList.remove('search-open');
      }
    });

    // Run once on load in case of a pre-filled value
    updatePlaceholderVisibility();
    function schedule(fn, delay) {
      timer = setTimeout(fn, delay);
    }

    // Reveals `word` left-to-right; cursor rides the leading edge.
    function revealWord(word) {
      //cursor.classList.remove("hidden", "blinking");
      typed.textContent = word;

      // Reset both text clip and cursor position instantly (no transition)
      typed.style.transition = 'none';
      typed.style.clipPath = 'inset(0 100% 0 0)';
      cursor.style.transition = 'none';
      cursor.style.transform = 'translateX(0px)';
      void typed.offsetWidth; // force reflow

      const wordWidth = typed.offsetWidth; // full box width (clip-path doesn't affect layout size)
      const duration = Math.max(minRevealMs, word.length * revealMsPerChar);

      typed.style.transition = `clip-path ${duration}ms ease-out`;
      cursor.style.transition = `transform ${duration}ms ease-out`;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          typed.style.clipPath = 'inset(0 0 0 0)';
          cursor.style.transform = `translateX(${wordWidth}px)`;
        });
      });

      return duration;
    }

    // Hides `word` right-to-left; cursor rides the trailing edge back to 0,
    // then disappears entirely once fully hidden.
    function hideWord(word) {
      cursor.classList.remove('blinking'); // stop blinking, move solid

      const duration = Math.max(minHideMs, word.length * hideMsPerChar);
      typed.style.transition = `clip-path ${duration}ms ease-in`;
      cursor.style.transition = `transform ${duration}ms ease-in`;

      typed.style.clipPath = 'inset(0 100% 0 0)';
      cursor.style.transform = 'translateX(0px)';

      return duration;
    }

    function step() {
      if (isUserActive()) {
        schedule(step, 300);
        return;
      }

      const word = words[wordIndex];
      const revealDuration = revealWord(word);

      schedule(() => {
        if (isUserActive()) {
          schedule(step, 300);
          return;
        }
        schedule(() => {
          if (isUserActive()) {
            schedule(step, 300);
            return;
          }

          const hideDuration = hideWord(word); // cursor rides back to 0 with the wipe

          schedule(() => {
            // cursor.classList.add("hidden"); // fully hidden once word is gone
            wordIndex = (wordIndex + 1) % words.length;
            schedule(step, pauseBeforeNext);
          }, hideDuration);
        }, pauseAfterTyped);
      }, revealDuration);
    }

    schedule(step, 500);
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setAnnouncementBarHeight();

      window.matchMedia('(max-width: 1560px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header?.offsetHeight}px`);
    }

    setAnnouncementBarHeight() {
      document.documentElement.style.setProperty(
        '--announcement-bar-height',
        `${this.announcementBar?.offsetHeight}px`
      );
    }

    setFilterTop(top) {
      document.documentElement.style.setProperty('--filter-top', `${top}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        const startTop = this.header.classList.contains('scrolled-past-header')
          ? this.header.getBoundingClientRect().top
          : null;
        this.header.classList.remove('scrolled-past-header');
        if (startTop !== null) {
          this.reset();
          this.slideFrom(startTop);
        } else {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.style.transition = '';
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.setFilterTop(0);
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.style.transition = '';
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setFilterTop(this.header?.offsetHeight);
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.setFilterTop(this.header?.offsetHeight);
    }

    slideFrom(startTop) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.header.style.transition = 'none';
      const offset = startTop - this.header.getBoundingClientRect().top;
      if (Math.abs(offset) < 1) {
        this.header.style.transition = '';
        return;
      }

      this.header.style.transform = `translateY(${offset}px)`;
      this.header.offsetHeight;
      this.header.style.transition = 'transform 0.45s cubic-bezier(0.22, 1, 0.36, 1)';
      this.header.style.transform = '';

      window.clearTimeout(this.slideTimer);
      this.slideTimer = setTimeout(() => {
        this.header.style.transition = '';
      }, 500);
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures?.forEach((disclosure) => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
